import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Game from '@/components/game'
import Pay from '@/components/pay'

Vue.use(Router)

export default new Router({
  mode: 'history',
  //base:'/home/',
  routes: [
    {
      path: '/',
      name: 'game',
      //component:() => import('@/components/index.vue')
      component:Game
    },
    // {
    //   path: '/game',
    //   name: 'game',
    //   component:Game
    // },
    {
      path: '*',
      name: 'game',
      component: Game
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js